<template>
  <ADropdown
    placement="right-end"
    popover-class="base-popover"
    :delay="{ show: 10, hide: 0 }"
    :triggers="['hover']"
    :popper-triggers="['hover']"
    :auto-hide="false"
  >
    <div class="nav-bar-item">
      <NavBarButton
        :to="to"
        :exact="exact"
        :highlight-enabled="highlightEnabled"
        :data-test-id="to ? `navbar-${to.name}-link` : $attrs['data-test-id'] ? $attrs['data-test-id'] : null"
        :font-color="fontColor"
      >
        <slot name="icon" />

        <template #title>
          {{ label }}
        </template>
      </NavBarButton>
    </div>
    <template #popper>
      <div class="nav-bar-item__tooltip">
        <span class="nav-bar-item__tooltip-text">
          {{ tooltipText || label }}
        </span>

        <ShortcutInfo v-if="shortcut" :shortcut="shortcut" class="nav-bar-item__shortcut-info" />
      </div>

      <slot name="popover" />
    </template>
  </ADropdown>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import NavBarButton from '@components/NavBar/NavBarButton.vue';

/**
 * NavBarItem wraps the NavBarButton and adds a tooltip
 * that is always shown on hover.
 *
 * Uses same styles as NavBarItem
 */
export default defineComponent({
  name: 'NavBarItemTooltipAlways',

  components: {
    NavBarButton,
  },

  props: {
    label: {
      type: String,
      required: true,
    },

    shortcut: {
      type: String,
      default: null,
    },

    to: {
      type: Object,
      default: null,
    },

    exact: {
      type: Boolean,
      default: false,
    },

    highlightEnabled: {
      type: Boolean,
      default: true,
    },

    fontColor: {
      type: String,
      default: 'default',
      validator(value) {
        return ['black', 'default'].includes(value);
      },
    },

    /**
     * Tooltip text. If not set, tooltip will have set the label property as text
     */
    tooltipText: {
      type: String,
      required: false,
      default: null,
    },
  },
});
</script>
